/* src/app/components/payroll/timesheets/timesheet-payroll-adjustment-approvals/timesheet-payroll-adjustment-approvals.component.css */
.table-style {
  width: 100%;
}
.error-message1 {
  color: red;
  font-size: 12px;
  margin-bottom: 4px;
}
::ng-deep ppl-popup-dialog div.popup-dialog.position-dialog div.content.medium {
  width: 90vw;
  max-width: 60%;
}
::ng-deep ppl-popup-dialog form div.alert.alert-warning {
  width: 100%;
}
::ng-deep ppl-timesheet-payroll-adjustment-approvals ppl-popup-dialog div.popup-dialog.position-dialog.center {
  top: 0;
  left: 0;
  height: 100vh;
}
.contrast-colors {
  color: rgba(0, 0, 0, 0.85);
  background-color: #fff;
}
/*# sourceMappingURL=timesheet-payroll-adjustment-approvals.component-JWVMDIVC.css.map */
